var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('colab-header'),_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('router-view')],1),_c('vue-snotify')],1)}
var staticRenderFns = []

export { render, staticRenderFns }